


import React from 'react';
import moment from 'moment';

const RefundPrint = ({ contentRef, formData }) => {
    return (
        <div ref={contentRef} style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', backgroundColor: 'white' }}>
            {/* Header */}
            <div style={{ marginBottom: '20px' }}>
                <h1 style={{ fontSize: '30px', textAlign: 'left', color: '#635bff', marginBottom: '4px' }}>
                    Payment Voucher
                </h1>
                {/* <h1 style={{ textAlign: 'left', marginBottom: '16px' }}>Official Refund / Disbursement Record</h1> */}
            </div>

            {/* Details Section */}
            <div style={{ marginBottom: '20px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #e5e7eb' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#635bff' }}>
                            <th style={{ fontSize: '20px', padding: '8px', border: '1px solid #e5e7eb', textAlign: 'left', color: 'white', fontWeight: 'bold' }} colSpan="4">Refund Summary</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style={{ fontSize: '17px', backgroundColor: '#f9fafb' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Voucher No</td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{formData?.PytNo || 'N/A'}</td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Date</td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{formData?.PytDt ? moment(formData.PytDt).format('DD-MM-YYYY') : new Date().toLocaleDateString()}</td>
                        </tr>
                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Resident</td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{formData?.ResidentId || 'N/A'}</td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Payment Mode</td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{formData?.Pyttype || 'N/A'}</td>
                        </tr>
                        <tr style={{ fontSize: '17px', backgroundColor: 'white' }}>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Amount</td>
                           <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{`₹ ${(Number(formData?.RcdAmt) || 0).toFixed(2)}`}</td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: '600' }}>Remarks</td>
                            <td style={{ padding: '8px', border: '1px solid #e5e7eb' }}>{formData?.Remark || '—'}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Amount in Words Section */}
            <div style={{ marginBottom: '20px' }}>
                <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: '#635bff', marginBottom: '8px' }}>Amount in Words</h3>
                <div style={{ padding: '10px', border: '1px solid #e5e7eb', borderRadius: '4px', backgroundColor: '#f9fafb' }}>
                    {amountToWords(formData?.RcdAmt || 0)}
                </div>
            </div>

            {/* Footer */}
            <div style={{ marginTop: '16px', fontSize: '15px' }}>
                <p style={{ marginBottom: '4px' }}>Thank you for choosing Clanbridge Living Pvt Ltd</p>
                <p>For any queries, please contact: support@clanbridgeliving.in</p>
            </div>
        </div>
    );
};

// Utility function to convert amount to words
const amountToWords = (amount) => {
    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const units = ["", "Thousand", "Lakh", "Crore"];

    if (isNaN(amount)) return "Invalid amount";

    let [integerPart, decimalPart] = Number(amount)?.toFixed(2).split(".");
    let words = "";

    const getWords = (num) => {
        let word = "";

        if (num > 99) {
            word += ones[Math.floor(num / 100)] + " Hundred ";
            num = num % 100;
        }

        if (num > 9 && num < 20) {
            word += teens[num - 10] + " ";
        } else if (num >= 20) {
            word += tens[Math.floor(num / 10)] + " ";
            word += ones[num % 10] + " ";
        } else if (num > 0) {
            word += ones[num] + " ";
        }

        return word.trim();
    };

    const numStr = integerPart.toString();
    const numLength = numStr.length;
    let i = 0, pos = 0;

    while (numLength - i > 0) {
        let divider = (pos === 0) ? 3 : 2;
        let part = parseInt(numStr.substring(Math.max(0, numLength - i - divider), numLength - i));
        if (part) {
            words = getWords(part) + " " + (units[pos] || "") + " " + words;
        }
        i += divider;
        pos++;
    }

    words = words.trim() + " Rupees";

    if (parseInt(decimalPart) > 0) {
        const paise = getWords(parseInt(decimalPart));
        words += " and " + paise + " Paise";
    }

    return words + " Only";
};

export default RefundPrint;
